import { useParams } from "@tanstack/react-router";

import { RequestDocumentsSection } from "./RequestDocumentsSection";

/**
 * Case-detail "Request documents" tab (doctor/staff). Referrers get this same
 * content as an inline section under Case Details instead of a tab — both render
 * the shared `RequestDocumentsSection`.
 */
const RequestDocumentsPage = () => {
  const { id: caseNumber } = useParams({ strict: false }) as { id: string };

  return (
    <div className="h-full overflow-y-auto">
      <div className="mx-auto max-w-4xl">
        <RequestDocumentsSection caseNumber={caseNumber} />
      </div>
    </div>
  );
};

export default RequestDocumentsPage;
